/**
 * @mps
 * @ness
 */

/**
 * MPS 상품인지 확인
 */
// 객체
export const isMpsProduct = (goodsTypeId: unknown): goodsTypeId is 'MPS' => {
  return goodsTypeId === 'MPS';
};
// 데이터
export const isMpsProductData = (data: { goodsTypeId: unknown }): data is { goodsTypeId: 'MPS' } => {
  return isMpsProduct(data.goodsTypeId);
};

/**
 * PBG 상품인지 확인
 */
// 데이터
export const isPbgProduct = (goodsTypeId: unknown): goodsTypeId is 'PBG' => {
  return goodsTypeId === 'PBG';
};
// 객체
export const isPbgProductData = (data: { goodsTypeId: unknown }): data is { goodsTypeId: 'PBG' } => {
  return isPbgProduct(data.goodsTypeId);
};

/**
 * TPL 상품인지 확인
 */
// 데이터
export const isTplProduct = (goodsTypeId: unknown): goodsTypeId is 'TPL' => {
  return goodsTypeId === 'TPL';
};
// 객체
export const isTplProductData = (data: { goodsTypeId: unknown }): data is { goodsTypeId: 'TPL' } => {
  return isTplProduct(data.goodsTypeId);
};

/**
 * DTG 상품인지 확인
 */
// 데이터
export const isDtgProduct = (goodsTypeId: unknown): goodsTypeId is 'DTG' => {
  return goodsTypeId === 'DTG';
};
// 객체
export const isDtgProductData = (data: { goodsTypeId: unknown }): data is { goodsTypeId: 'DTG' } => {
  return isDtgProduct(data.goodsTypeId);
};
